module.exports = __webpack_public_path__ + "static/media/cat5.c1138a62.jpg";